import { useState, useCallback } from 'react';
import Notification, { NotificationType } from '../components/Notification/Notification';

interface NotificationData {
  id: number;
  message: string;
  type: NotificationType;
}

export const useNotification = () => {
  const [notifications, setNotifications] = useState<NotificationData[]>([]);
  const [nextId, setNextId] = useState(1);

  const showNotification = useCallback((message: string, type: NotificationType) => {
    const id = nextId;
    setNextId(prev => prev + 1);
    setNotifications(prev => [...prev, { id, message, type }]);
  }, [nextId]);

  const closeNotification = useCallback((id: number) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  }, []);

  const NotificationContainer = useCallback(() => (
    <>
      {notifications.map(notification => (
        <Notification
          key={notification.id}
          message={notification.message}
          type={notification.type}
          onClose={() => closeNotification(notification.id)}
        />
      ))}
    </>
  ), [notifications, closeNotification]);

  return {
    showSuccess: (message: string) => showNotification(message, 'success'),
    showError: (message: string) => showNotification(message, 'error'),
    NotificationContainer
  };
};
